import { mapActions } from 'vuex';
import alertBox from '@/components/generics/alert-box/alert-box.vue';
import { STATIC_PAGES } from '@/constants';
import log from '@/logger';
import { isEmptyHtml } from '@/utils/helpers';

export default {
  components: {
    alertBox,
  },
  data() {
    return {
      depositWarning: '',
    };
  },
  methods: {
    ...mapActions('browse', ['getStaticPageFull']),
  },
  created() {
    this.getStaticPageFull(STATIC_PAGES.DEPOSIT_WARNING)
      .then((data) => {
        if (!isEmptyHtml(data.renderedHTML)) {
          this.depositWarning = data.renderedHTML;
        }
      })
      .catch((error) => {
        log.error('Failed to load deposit warning content.', error);
        this.depositWarning = '';
      });
  },
};
